import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

// frontend component card --- function to cal op

export const products = [
  {
    _id: uuid(),
    brandName: "Urban Cado",
    description: "Women's Urban Cado pink bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/mr3ym87c", "https://tinyurl.com/yckrnbf4", "https://tinyurl.com/55z2z6sr", "https://tinyurl.com/2p9d2ejy"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "20",
    discountedPrice: 1000,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Zego",
    description: "Zego, a vegan & eco-friendly leather bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/5b96ynyp", "https://tinyurl.com/2fun8n47", "https://tinyurl.com/4cf36f8d", "https://tinyurl.com/4k4vf743"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "65",
    discountedPrice: 900,
    rating: 3.7,
  },
  {
    _id: uuid(),
    brandName: "Leisara",
    description: "Women stylish blue bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/yrbbn9ww", "https://tinyurl.com/2p8ftrn8", "https://tinyurl.com/vhu5secn"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "40",
    discountedPrice: 8556,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Indiano",
    description: "Handmade Bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/2p8kc847", "https://tinyurl.com/43rf3h76"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "5",
    discountedPrice: 800,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Louis Vuitton",
    description: "Women's green shoulder+hand bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/2m7s7kmd", "https://tinyurl.com/2k24c8b7"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 5000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Tamaras",
    description: "Black shiny stylish bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/6t6ex347", "https://tinyurl.com/388645wr"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "3",
    discountedPrice: 500,
    rating: 2,
  },
  {
    _id: uuid(),
    brandName: "Vinta",
    description: "Camera Bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/2p8h6bx2", "https://tinyurl.com/2p9k7akt"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women"],
    discount: "",
    discountedPrice: 765,
    rating: 2.5,
  },
  {
    _id: uuid(),
    brandName: "Chanel",
    description: "Women's blue handbag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/39n43x8a", "https://tinyurl.com/2p9fx7fb", "https://tinyurl.com/4cds8tnj"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "5",
    discountedPrice: 10000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Ladida",
    description: "Stylish handbag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/4t79du7x", "https://tinyurl.com/27aasj3m"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 3000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Dora",
    description: "Pink Dora bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/6cx6f5wx", "https://tinyurl.com/4htkjd5e", "https://tinyurl.com/2p84h37z"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 6547,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Pearlit",
    description: "Pearls Bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/3ttxfn53", "https://tinyurl.com/2v23x6sm", "https://tinyurl.com/53bsk398", "https://tinyurl.com/nyc4vjnx"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 800,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Peak",
    description: "Peak design bagpack",
    categoryName: "Bags",
    img: ["https://tinyurl.com/5xtntkp6", "https://tinyurl.com/2x4edus5", "https://tinyurl.com/5a8vd6r3", "https://tinyurl.com/9xjptayc", "https://tinyurl.com/2p8ccdt8"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "30",
    discountedPrice: 2000,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Chanel",
    description: "Chanel's Bag",
    categoryName: "Bags",
    img: ["https://tinyurl.com/37nhjcdd", "https://tinyurl.com/4zzh32n7", "https://tinyurl.com/3z4jh5zr", "https://tinyurl.com/4anzrue9"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "5",
    discountedPrice: 500,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Nora",
    description: "Nora skincare products",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/bde32z7h", "https://tinyurl.com/2p8dvfed", "https://tinyurl.com/muhwvx95"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women"],
    discount: "50",
    discountedPrice: 986,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Notpot",
    description: "Skincare product",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/3yf349me", "https://tinyurl.com/mpm2nbpv"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: false,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "35",
    discountedPrice: 400,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Poko",
    description: "Soothing cream",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/3s53xv9z", "https://tinyurl.com/y384v996", "https://tinyurl.com/2p9ypfyw", "https://tinyurl.com/mr2f4fxr"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 900,
    rating: 1.5,
  },
  {
    _id: uuid(),
    brandName: "Poko",
    description: "Luxury facial oil",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/48nvzzma", "https://tinyurl.com/2p874aae", "https://tinyurl.com/ph3c9b65"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "80",
    discountedPrice: 1200,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Tatcha",
    description: "Cleansing oil",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/mztjmyar", "https://tinyurl.com/ezudrsj7"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "95",
    discountedPrice: 6200,
    rating: 4.2,
  },
  {
    _id: uuid(),
    brandName: "CBD",
    description: "Lotion+Muscle gel combo",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/2yfbznec", "https://tinyurl.com/25z7a5kc", "https://tinyurl.com/zuahtt5f", "https://tinyurl.com/3pta27ma"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "",
    discountedPrice: 1500,
    rating: 2.5,
  },
  {
    _id: uuid(),
    brandName: "OrganiCup",
    description: "Women's tampon",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/4jx56z98", "https://tinyurl.com/2p8jr6e4"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 500,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Plum",
    description: "Plum body lovin cream",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/5n7xhtwd", "https://tinyurl.com/32mp9xt2", "https://tinyurl.com/m6677mrk", "https://tinyurl.com/2p958hvs"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 1600,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Biolabs",
    description: "Hair serum",
    categoryName: "Bodycare Products",
    img: ["https://tinyurl.com/2p8kuxcc", "https://tinyurl.com/yc2w3du8", "https://tinyurl.com/mujbbznp"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women"],
    discount: "",
    discountedPrice: 799,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Durian",
    description: "Pure white sofa",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/2p86shet", "https://tinyurl.com/zb98b7u9"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 1999,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Godrej Interio",
    description: "Blue padded chair",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/2p8mcxu3", "https://tinyurl.com/395pnykc"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "",
    discountedPrice: 1099,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Usha",
    description: "Regular wooden chair",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/2p9crha3", "https://tinyurl.com/2afjf33a", "https://tinyurl.com/3zyh5xf2", "https://tinyurl.com/4rdexfmz"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 2000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Usha",
    description: "Wooden Table",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/9ezuuse2", "https://tinyurl.com/2j67aa9c"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "",
    discountedPrice: 5000,
    rating: 4.1,
  },
  {
    _id: uuid(),
    brandName: "Ikea",
    description: "Fashionable lamp",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/2p9df8xw", "https://tinyurl.com/mus56mum"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "50",
    discountedPrice: 50000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Durian",
    description: "White lamp",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/2p9ywh9m", "https://tinyurl.com/462kabhe"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "50",
    discountedPrice: 25000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Durian",
    description: "Bed",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/f3wuk93h", "https://tinyurl.com/rhh5svp2"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "50",
    discountedPrice: 20000,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Durian",
    description: "Pillow",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/tb8xtzfe", "https://tinyurl.com/5n84bakj"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "50",
    discountedPrice: 800,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Ikea",
    description: "Vase",
    categoryName: "Furniture",
    img: ["https://tinyurl.com/mrycdzbp", "https://tinyurl.com/58w5xn5k"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "50",
    discountedPrice: 800,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Level",
    description: "Black wireless headphones",
    categoryName: "Headphones",
    img: ["https://tinyurl.com/5n8z54pt", "https://tinyurl.com/yc7zezsx", "https://tinyurl.com/2p9e47wz", "https://tinyurl.com/23ekz6zr"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "90",
    discountedPrice: 1100,
    rating: 3.8,
  },
  {
    _id: uuid(),
    brandName: "Sony",
    description: "Classic bluetooth headphones",
    categoryName: "Headphones",
    img: ["https://tinyurl.com/5d2snnha", "https://tinyurl.com/2p8n2pme", "https://tinyurl.com/2p99ky34", "https://tinyurl.com/3uph3xce", "https://tinyurl.com/ycxbe4vp", "https://tinyurl.com/2p84fe82"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "",
    discountedPrice: 4000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Aedie",
    description: "Gold beats headphone",
    categoryName: "Headphones",
    img: ["https://tinyurl.com/2wczmarp", "https://tinyurl.com/y8hj3x8e"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 8756,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Boat",
    description: "Black corded headphone",
    categoryName: "Headphones",
    img: ["https://tinyurl.com/58fatsjt", "https://tinyurl.com/ys2zt52k", "https://tinyurl.com/5exsb4y8", "https://tinyurl.com/2p9bvv6k"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "20",
    discountedPrice: 2000,
    rating: 3.7,
  },
  {
    _id: uuid(),
    brandName: "Beats",
    description: "Beats wireless headphones",
    categoryName: "Headphones",
    img: ["https://tinyurl.com/bddmkpdr", "https://tinyurl.com/4pvxznvk", "https://tinyurl.com/2p8b2hba", "https://tinyurl.com/2p8rv827"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "50",
    discountedPrice: 1265,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Channel",
    description: "Golden locket",
    categoryName: "Jewellery",
    img: ["https://tinyurl.com/yty5rcv2", "https://tinyurl.com/y3xz4twd"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "50",
    discountedPrice: 800,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Diamond Jewels",
    description: "Diamond ring",
    categoryName: "Jewellery",
    img: ["https://tinyurl.com/29tucjut", "https://tinyurl.com/2p8nsbre"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 100000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "H&H Jewels",
    description: "Gold ring",
    categoryName: "Jewellery",
    img: ["https://tinyurl.com/3pmyz7j7"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "",
    discountedPrice: 50000,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Jess Jewellers",
    description: "Diamond ring",
    categoryName: "Jewellery",
    img: ["https://tinyurl.com/33hdj6a7", "https://tinyurl.com/44w6zprs", "https://tinyurl.com/3m9ur69c", "https://tinyurl.com/yc2zjb59", "https://tinyurl.com/4db5xhme"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "30",
    discountedPrice: 95000,
    rating: 3.1,
  },
  {
    _id: uuid(),
    brandName: "Miss Curious",
    description: "Silver touch artificial ring",
    categoryName: "Jewellery",
    img: ["https://tinyurl.com/46fkpz6s", "https://tinyurl.com/mwnvtkmr", "https://tinyurl.com/2p8m44md"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 1000,
    rating: 2.5,
  },
  {
    _id: uuid(),
    brandName: "Bohemian",
    description: "Diamond ring",
    categoryName: "Jewellery",
    img: ["https://tinyurl.com/ywa4u2pr", "https://tinyurl.com/2tbvftce", "https://tinyurl.com/bdhkwxdc"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "15",
    discountedPrice: 87500,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Prestige",
    description: "Personal holding grater",
    categoryName: "Kitchen utensils",
    img: ["https://tinyurl.com/2p98hh5z", "https://tinyurl.com/42jy4rs4"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "",
    discountedPrice: 5000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Prestige",
    description: "Silver spoons",
    categoryName: "Kitchen utensils",
    img: ["https://tinyurl.com/3z895wrc"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "10",
    discountedPrice: 400,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Ionic Crafters",
    description: "Wooden table spoons set",
    categoryName: "Kitchen utensils",
    img: ["https://tinyurl.com/2p89fa98", "https://tinyurl.com/5n8u4jda", "https://tinyurl.com/ykws5xsm"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "15",
    discountedPrice: 600,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Ionic Crafters",
    description: "Black and brown mortar and pestle",
    categoryName: "Kitchen utensils",
    img: ["https://tinyurl.com/4985mvvv", "https://tinyurl.com/44ecj9f8", "https://tinyurl.com/2h53znhk"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "5",
    discountedPrice: 6000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Prestige",
    description: "Mortal and pestle",
    categoryName: "Kitchen utensils",
    img: ["https://tinyurl.com/2p8bmx59", "https://tinyurl.com/427un495"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "20",
    discountedPrice: 1233,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Balmuda",
    description: "Kettle",
    categoryName: "Kitchen utensils",
    img: ["https://tinyurl.com/mecp2fss"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "10",
    discountedPrice: 999,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Prestige",
    description: "Jars",
    categoryName: "Kitchen utensils",
    img: ["https://tinyurl.com/bdd3ytrc"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "",
    discountedPrice: 1299,
    rating: 3.8,
  },
  {
    _id: uuid(),
    brandName: "NYX",
    description: "Glow makeup serum",
    categoryName: "Makeup",
    img: ["https://tinyurl.com/2p8ddrxa", "https://tinyurl.com/m4cxa3e2", "https://tinyurl.com/2szueza6"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 5555,
    rating: 3.8,
  },
  {
    _id: uuid(),
    brandName: "Givenchy",
    description: "Givenchy cosmetic set",
    categoryName: "Makeup",
    img: ["https://tinyurl.com/2p9bxztb", "https://tinyurl.com/esud584s", "https://tinyurl.com/4a63nj7s", "https://tinyurl.com/2p8pk2py"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 5569,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Miss swiss",
    description: "Miss swiss makeup brush set",
    categoryName: "Makeup",
    img: ["https://tinyurl.com/24v7d7ue", "https://tinyurl.com/yckwu8yh", "https://tinyurl.com/2mxhayyv", "https://tinyurl.com/4xkrw9s3"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "15",
    discountedPrice: 10999,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Miss swiss",
    description: "Miss swiss makeup storing case",
    categoryName: "Makeup",
    img: ["https://tinyurl.com/ycy9cmvb", "https://tinyurl.com/ycyanpca", "https://tinyurl.com/5n9ajb6u", "https://tinyurl.com/bdfttfy2"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "40",
    discountedPrice: 879,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "M.A.C",
    description: "Eyeshadow pallette",
    categoryName: "Makeup",
    img: ["https://tinyurl.com/2s4zafkj", "https://tinyurl.com/59sv3vsx", "https://tinyurl.com/4a5t83ve"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "40",
    discountedPrice: 1599,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Lakme",
    description: "Makeup palette",
    categoryName: "Makeup",
    img: ["https://tinyurl.com/yckm9uev", "https://tinyurl.com/2s3huctc", "https://tinyurl.com/mv5nnzjy"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 1299,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Chanel",
    description: "Lipstick",
    categoryName: "Makeup",
    img: ["https://tinyurl.com/t393uhm", "https://tinyurl.com/nhzshrat", "https://tinyurl.com/2p929x2d"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 1299,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Atoms",
    description: "Atoms mask",
    categoryName: "Masks",
    img: ["https://tinyurl.com/2p8n5een", "https://tinyurl.com/2p8fk9wt", "https://tinyurl.com/yu8n4bdy", "https://tinyurl.com/yvzxzkjc"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: false,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "",
    discountedPrice: 799,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Adiddas",
    description: "Classic masks",
    categoryName: "Masks",
    img: ["https://tinyurl.com/yc6u4ks5", "https://tinyurl.com/46tpcu53", "https://tinyurl.com/4cvyhpuj"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "10",
    discountedPrice: 399,
    rating: 2.5,
  },
  {
    _id: uuid(),
    brandName: "Apple",
    description: "Macbook pro",
    categoryName: "Mobiles",
    img: ["https://tinyurl.com/yckskpfk", "https://tinyurl.com/mpaadejj", "https://tinyurl.com/5n8uannk"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "20",
    discountedPrice: 55000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Apple",
    description: "White iPhone 7",
    categoryName: "Mobiles",
    img: ["https://tinyurl.com/yfwxds3j", "https://tinyurl.com/mpwp5s2", "https://tinyurl.com/2p95myce"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "5",
    discountedPrice: 45000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Apple",
    description: "Black iPhone 7",
    categoryName: "Mobiles",
    img: ["https://tinyurl.com/285bdd6x", "https://tinyurl.com/5xe5nkvh", "https://tinyurl.com/2s4e3mu9"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "5",
    discountedPrice: 45000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Daisy",
    description: "Perfume bottle for womens",
    categoryName: "Perfumes",
    img: ["https://tinyurl.com/38bhzmtb", "https://tinyurl.com/bdfw98u", "https://tinyurl.com/yckk867c", "https://tinyurl.com/3yhw6975", "https://tinyurl.com/bdftvv5b"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "5",
    discountedPrice: 5500,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Chanel",
    description: "Chanel coco perfume",
    categoryName: "Perfumes",
    img: ["https://tinyurl.com/3j37f445", "https://tinyurl.com/2p8zcp86", "https://tinyurl.com/23uscbuw", "https://tinyurl.com/yyddhmv5"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "20",
    discountedPrice: 4000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Givenchy",
    description: "L'interdit givenchy perfume",
    categoryName: "Perfumes",
    img: ["https://tinyurl.com/3wdyrj9z", "https://tinyurl.com/5fb7tdmu", "https://tinyurl.com/tbu83y7k", "https://tinyurl.com/39hs8z2a", "https://tinyurl.com/3wb442zd"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "",
    discountedPrice: 4000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Marc Jacobs",
    description: "Soothing perfume",
    categoryName: "Perfumes",
    img: ["https://tinyurl.com/4usw39c4", "https://tinyurl.com/5d5rjyc9", "https://tinyurl.com/2mr4txbr", "https://tinyurl.com/djfxdmrs"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 7000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "BharatSthali",
    description: "Plane pink saree with border",
    categoryName: "Saree",
    img: ["https://tinyurl.com/ywt3vphv", "https://tinyurl.com/2mvm7ece", "https://tinyurl.com/2p9dxk5p"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 1999,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "BharatSthali",
    description: "Banarasi print green saree",
    categoryName: "Saree",
    img: ["https://tinyurl.com/rz8snjne", "https://tinyurl.com/2p96k3bm", "https://tinyurl.com/yjcdfza7"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 3409,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Kalanjali",
    description: "Grey cotton saree with pink border",
    categoryName: "Saree",
    img: ["https://tinyurl.com/5axxkyxv", "https://tinyurl.com/5n6t9z7t", "https://tinyurl.com/2p93s8pd", "https://tinyurl.com/ys7r4fmc"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 2300,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Nike",
    description: "White nike shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/49ymamwr", "https://tinyurl.com/ysr9eadu", "https://tinyurl.com/3whec3wn"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "",
    discountedPrice: 3476,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Air Jordan",
    description: "Kids Air Jordan 5 Shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/yc6s95k2", "https://tinyurl.com/5477n5nh", "https://tinyurl.com/bdapz2r5", "https://tinyurl.com/5ycf5vhc", "https://tinyurl.com/97twhp64"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Kids"],
    discount: "10",
    discountedPrice: 5889,
    rating: 3.8,
  },
  {
    _id: uuid(),
    brandName: "Air Jordan",
    description: "White and Red air jordan 12 shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/nzc7yr62", "https://tinyurl.com/2bs2t7e8", "https://tinyurl.com/2p8funpz"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Kids"],
    discount: "20",
    discountedPrice: 4873,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Chanel",
    description: "Women's heel shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/2p8dpbfk", "https://tinyurl.com/2p8jk4xn", "https://tinyurl.com/ybzxby9c"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "5",
    discountedPrice: 8899,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Chanel",
    description: "Men shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/3uwwb2tu", "https://tinyurl.com/2p98c2kj", "https://tinyurl.com/ycksmcnt"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Kids"],
    discount: "5",
    discountedPrice: 1287,
    rating: 3.7,
  },
  {
    _id: uuid(),
    brandName: "Air Jordan",
    description: "Orange and Black ir Jordan 5 shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/2yc647n3", "https://tinyurl.com/4j2u76ze", "https://tinyurl.com/2p82rf8w", "https://tinyurl.com/4245rmsy", "https://tinyurl.com/3w4dr67c", "https://tinyurl.com/29bwe6k3"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Kids"],
    discount: "",
    discountedPrice: 3999,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Air Jordan",
    description: "Pink and Black air Jordan 5 shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/4k728mmr", "https://tinyurl.com/2c48cnj4", "https://tinyurl.com/bdhd6sk6", "https://tinyurl.com/bdr4hx4d", "https://tinyurl.com/ybae8j9b"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Kids"],
    discount: "",
    discountedPrice: 4999,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Nike",
    description: "White nike shoes",
    categoryName: "Shoes",
    img: ["https://tinyurl.com/mse74sun", "https://tinyurl.com/2p8a32ya", "https://tinyurl.com/yw6rwjxz", "https://tinyurl.com/244st3uk"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women"],
    discount: "",
    discountedPrice: 2999,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Nike",
    description: "Nike polo men's shirt",
    categoryName: "Professionals",
    img: ["https://tinyurl.com/yckh3kma", "https://tinyurl.com/2n54nbza", "https://tinyurl.com/y32pdayk", "https://tinyurl.com/yc3w2797", "https://tinyurl.com/3a8dms97"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "10",
    discountedPrice: 1000,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Nike",
    description: "Nike button up shirt",
    categoryName: "Professionals",
    img: ["https://tinyurl.com/bddfwnr6", "https://tinyurl.com/yckyxuc6", "https://tinyurl.com/mrx5duwk"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "5",
    discountedPrice: 1200,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Chanel",
    description: "Brown coat and pant pair for women",
    categoryName: "Professionals",
    img: ["https://tinyurl.com/mtbpermb", "https://tinyurl.com/2p95u58k"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "5",
    discountedPrice: 10000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Ignite",
    description: "Black leather strap gold and black chronograph watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/4v8vr766", "https://tinyurl.com/yeyrzs3u", "https://tinyurl.com/d4pa6vn5"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "10",
    discountedPrice: 20000,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Anne Klein",
    description: "Women's analog watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/ywek67rk", "https://tinyurl.com/2s3n7hu7"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 3000,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Seiko",
    description: "Black analog watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/yc33ysys", "https://tinyurl.com/5n9xsjua", "https://tinyurl.com/2p8a9dj6"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "20",
    discountedPrice: 3498,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Titen",
    description: "Analog watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/2dxpcm75", "https://tinyurl.com/5n8r4r73", "https://tinyurl.com/2p95c6he"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "20",
    discountedPrice: 20000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Quartz",
    description: "Men's analog watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/bdek39pu", "https://tinyurl.com/2p98u6f6", "https://tinyurl.com/264uf799"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "20",
    discountedPrice: 15999,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Samsung",
    description: "Digital black watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/y2y7mw4e", "https://tinyurl.com/4f562zn2"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "20",
    discountedPrice: 2000,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Apple",
    description: "Digital White watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/jc8hnf2k", "https://tinyurl.com/4tc6z7ee", "https://tinyurl.com/dwz3m655"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "20",
    discountedPrice: 30000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Apple",
    description: "Digital Black watch",
    categoryName: "Watches",
    img: ["https://tinyurl.com/yckzu95e", "https://tinyurl.com/2p8tdmj9", "https://tinyurl.com/hf2xyuzf", "https://tinyurl.com/yc7jcyrf"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men", "Kids"],
    discount: "20",
    discountedPrice: 45000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Aliance",
    description: "White cylindrical Water Bottles",
    categoryName: "Water Bottles",
    img: ["https://tinyurl.com/5n745vy8", "https://tinyurl.com/sxrrctbc"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "20",
    discountedPrice: 700,
    rating: 3.7,
  },
  {
    _id: uuid(),
    brandName: "Bindle",
    description: "Multipurpose water bottle",
    categoryName: "Water Bottles",
    img: ["https://tinyurl.com/k9f2svwd", "https://tinyurl.com/329b46b3"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "",
    discountedPrice: 899,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Quokka",
    description: "Quokka sqaure Bottles",
    categoryName: "Water Bottles",
    img: ["https://tinyurl.com/y6mdc9b5", "https://tinyurl.com/nz845me8", "https://tinyurl.com/bdcrexfz"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 559,
    rating: 3,
  },
  {
    _id: uuid(),
    brandName: "Adiddas",
    description: "Black and white adiddas tumbler",
    categoryName: "Water Bottles",
    img: ["https://tinyurl.com/5n76he6z", "https://tinyurl.com/bdfdmej3"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 987,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Kit And Ace",
    description: "Black rubber Bottle",
    categoryName: "Water Bottles",
    img: ["https://tinyurl.com/2c9nz9t8", "https://tinyurl.com/4hhb5cxj", "https://tinyurl.com/3aec79sw"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "30",
    discountedPrice: 999,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Levis",
    description: "Stainless steel Bottle",
    categoryName: "Water Bottles",
    img: ["https://tinyurl.com/ywrk2hfv", "https://tinyurl.com/rznu5rsv", "https://tinyurl.com/2xwxnh5h"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 2799,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Kit And Ace",
    description: "Grey foldable water bottle",
    categoryName: "Water Bottles",
    img: ["https://tinyurl.com/h7y358p3", "https://tinyurl.com/yptcstd6", "https://tinyurl.com/yru9epn5"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women", "Kids"],
    discount: "10",
    discountedPrice: 2000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Louis Vuitton",
    description: "Off White hoodie",
    categoryName: "Western",
    img: ["https://tinyurl.com/yc2drxsv", "https://tinyurl.com/ycxxb8re", "https://tinyurl.com/529sfyeu"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "10",
    discountedPrice: 599,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Ralph Lauren",
    description: "White off shoulder dress",
    categoryName: "Western",
    img: ["https://tinyurl.com/2jarntnh", "https://tinyurl.com/2p965sc5"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 1399,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Ralph Lauren",
    description: "Pink dress",
    categoryName: "Western",
    img: ["https://tinyurl.com/2p9ydxu6", "https://tinyurl.com/mr9vp6vv"],
    isNewArrival: true,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Kids"],
    discount: "10",
    discountedPrice: 4500,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Prada",
    description: "Denim blue jacket",
    categoryName: "Western",
    img: ["https://tinyurl.com/4h8yptfr", "https://tinyurl.com/ycyryunv"],
    isNewArrival: true,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 2500,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Prada",
    description: "White tube dress",
    categoryName: "Western",
    img: ["https://tinyurl.com/yc6nvkk2", "https://tinyurl.com/2vj7r5wy", "https://tinyurl.com/yc768njy"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 10500,
    rating: 3.8,
  },
  {
    _id: uuid(),
    brandName: "Gucci",
    description: "Blue washed jacket",
    categoryName: "Western",
    img: ["https://tinyurl.com/59hnwc7n", "https://tinyurl.com/4pem4y9k", "https://tinyurl.com/ry5pvb8x"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 4999,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Burberry",
    description: "Black jacket",
    categoryName: "Western",
    img: ["https://tinyurl.com/4p8dzerh", "https://tinyurl.com/4m2kj8v2", "https://tinyurl.com/y8vf97p2"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: true,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "30",
    discountedPrice: 2000,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Integrity",
    description: "Brown half sleeves shirt",
    categoryName: "Western",
    img: ["https://tinyurl.com/aufzd9pd", "https://tinyurl.com/yckcztbu"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 1500,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Integrity",
    description: "Red polks dot dress",
    categoryName: "Western",
    img: ["https://tinyurl.com/43ckyeh6", "https://tinyurl.com/y85873xd"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 4500,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Burberry",
    description: "Light brown men's long coat",
    categoryName: "Western",
    img: ["https://tinyurl.com/2s3j6p7r", "https://tinyurl.com/4cxy5ywk", "https://tinyurl.com/5n6th496"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 8500,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Burberry",
    description: "Light brown men's long coat",
    categoryName: "Western",
    img: ["https://tinyurl.com/yf8b638s", "https://tinyurl.com/33cmamv2"],
    isNewArrival: false,
    hasDiscount: true,
    hasFastDelivery: false,
    isInStock: false,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "5",
    discountedPrice: 11500,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "Old Navy",
    description: "Green sweater",
    categoryName: "Winter",
    img: ["https://tinyurl.com/mr3mye8c", "https://tinyurl.com/2xdw6v4e"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 2200,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Old Navy",
    description: "Blue knit men's sweater",
    categoryName: "Winter",
    img: ["https://tinyurl.com/y6u22syj", "https://tinyurl.com/msh5634d"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "",
    discountedPrice: 1200,
    rating: 3.5,
  },
  {
    _id: uuid(),
    brandName: "Floralo",
    description: "Fur Jacket",
    categoryName: "Winter",
    img: ["https://tinyurl.com/ymbse7zp", "https://tinyurl.com/4m4dm29x", "https://tinyurl.com/2u4xnkvd", "https://tinyurl.com/2skzxusr"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 22000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Lofa",
    description: "Pink tshirt",
    categoryName: "Free Style",
    img: ["https://tinyurl.com/4j7crvjh", "https://tinyurl.com/2p89hw57"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women"],
    discount: "10",
    discountedPrice: 1000,
    rating: 4.6,
  },
  {
    _id: uuid(),
    brandName: "Floraloa",
    description: "White red and blue striped shirt and palazzo pants",
    categoryName: "Free Style",
    img: ["https://tinyurl.com/r7btw89m", "https://tinyurl.com/6m3zye2h"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "40",
    discountedPrice: 1000,
    rating: 3.7,
  },
  {
    _id: uuid(),
    brandName: "Floraloa",
    description: "White long sleeve shirt and matching pants",
    categoryName: "Free Style",
    img: ["https://tinyurl.com/yckk5z2r", "https://tinyurl.com/2p8nce4v", "https://tinyurl.com/mr37n76y"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 2000,
    rating: 4,
  },
  {
    _id: uuid(),
    brandName: "Floraloa",
    description: "Orange color tank top with floral design",
    categoryName: "Free Style",
    img: ["https://tinyurl.com/3m8y74db", "https://tinyurl.com/4czpfn5h"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 1359,
    rating: 4.8,
  },
  {
    _id: uuid(),
    brandName: "Lofa",
    description: "Stripped full length baggy dress",
    categoryName: "Free Style",
    img: ["https://tinyurl.com/3bvbbs38", "https://tinyurl.com/2s4jzsvt"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "10",
    discountedPrice: 1009,
    rating: 4.8,
  },
  {
    _id: uuid(),
    brandName: "Ray-Ban",
    description: "Ray-Ban sunglasses",
    categoryName: "Sunglasses",
    img: ["https://tinyurl.com/yc5v3uah", "https://tinyurl.com/3du4k43b", "https://tinyurl.com/mr2pm9w7", "https://tinyurl.com/4v4j8hvf"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: true,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "20",
    discountedPrice: 15000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Prada",
    description: "Prada oval shape sunglasses",
    categoryName: "Sunglasses",
    img: ["https://tinyurl.com/4erzhaf6", "https://tinyurl.com/4dwxzz9", "https://tinyurl.com/p8cstuhn"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: true,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men"],
    discount: "10",
    discountedPrice: 10000,
    rating: 4.5,
  },
  {
    _id: uuid(),
    brandName: "MVMTH",
    description: "Black sunglasses",
    categoryName: "Sunglasses",
    img: ["https://tinyurl.com/2p8waj6e", "https://tinyurl.com/4paxnfe2", "https://tinyurl.com/ufam89px", "https://tinyurl.com/mtvptads"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Men", "Women"],
    discount: "",
    discountedPrice: 25000,
    rating: 4.8,
  },
  {
    _id: uuid(),
    brandName: "Prada",
    description: "Stylish sunglasses",
    categoryName: "Sunglasses",
    img: ["https://tinyurl.com/3fz5je7w", "https://tinyurl.com/ycxbvxhr", "https://tinyurl.com/2p8em496"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women"],
    discount: "",
    discountedPrice: 50000,
    rating: 5,
  },
  {
    _id: uuid(),
    brandName: "Prada",
    description: "Black framed sunglasses with yellow lenses",
    categoryName: "Sunglasses",
    img: ["https://tinyurl.com/3t4ejf4d", "https://tinyurl.com/mvbuvt4f"],
    isNewArrival: false,
    hasDiscount: false,
    hasFastDelivery: false,
    isInStock: true,
    isInSale: false,
    isTrending: false,
    isAddedToCart: false,
    isLiked: false,
    isInSection: ["Women", "Men"],
    discount: "",
    discountedPrice: 7000,
    rating: 3.8,
  }
];
